import { Button } from "@mantine/core";
import {
  IconAlertTriangle,
  IconArrowLeft,
  IconFileOff,
  IconHome,
  IconRefresh,
} from "@tabler/icons-react";
import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import { ErrorState } from "./ErrorState";

/**
 * Trang lỗi dùng làm errorElement của router:
 * - 404: không tìm thấy trang / hồ sơ.
 * - Còn lại: lỗi hệ thống khi tải trang.
 */
const PageNotFound = () => {
  const navigate = useNavigate();
  const error = useRouteError();
  const is404 = isRouteErrorResponse(error) && error.status === 404;

  if (is404) {
    return (
      <ErrorState
        code={404}
        color="blue"
        icon={<IconFileOff size={52} />}
        title="Không tìm thấy trang"
        description="Trang hoặc hồ sơ bạn muốn mở không tồn tại, đã bị di chuyển hoặc đường dẫn không đúng. Vui lòng kiểm tra lại đường dẫn."
        actions={
          <>
            <Button
              leftSection={<IconArrowLeft size={16} />}
              variant="default"
              onClick={() => navigate(-1)}
            >
              Quay lại
            </Button>
            <Button
              leftSection={<IconHome size={16} />}
              onClick={() => navigate("/dashboard")}
            >
              Về trang chủ
            </Button>
          </>
        }
      />
    );
  }

  return (
    <ErrorState
      code={isRouteErrorResponse(error) ? error.status : 500}
      color="red"
      icon={<IconAlertTriangle size={52} />}
      title="Đã có lỗi xảy ra"
      description="Hệ thống gặp sự cố khi tải trang. Bạn vui lòng thử tải lại; nếu vẫn lỗi, liên hệ quản trị viên để được hỗ trợ."
      actions={
        <>
          <Button
            leftSection={<IconRefresh size={16} />}
            variant="default"
            onClick={() => window.location.reload()}
          >
            Tải lại
          </Button>
          <Button
            leftSection={<IconHome size={16} />}
            onClick={() => navigate("/dashboard")}
          >
            Về trang chủ
          </Button>
        </>
      }
    />
  );
};

export default PageNotFound;
